import { getECSobjPropVal } from './helpers';

export interface IUilogTracklinkParams {
  placement: string;
  identifier: string;
  type: string;
}
interface ApplyLinkParams {
  placement: string;
  filterFeatures?: string;
}
export enum EventName {
  trackLink = 'event_trackLink',
  offersDisplay = 'event_lgPlacementDisplayed',
  redirect = 'event_redirect',
  modalDisplay = 'event_modal',
  slider = 'event_slider',
  login = 'event_loginResponse',
  browser = 'temp_browser',
  alerts = 'event_returnUserAlert'
}
export function postUiLog(eventName: string, postData: Record<string, any>): void {
  if (typeof window !== 'undefined' && window.ECS && window.ECS.tms && window.ECS.tms.data) {
    window.ECS.tms.data.evt = eventName;
    delete window.ECS.tms.data.filter;
    if (window.ECS.tms.data.evt === EventName.trackLink) {
      delete window.ECS.tms.data.response;
      window.ECS.tms.data.trackLink = postData;
    } else {
      delete window.ECS.tms.data.trackLink;
      window.ECS.tms.data.response = postData;
    }
    // Invoke Ensighten event
    if (window.ECS.tms.trigger) {
      window.ECS.tms.trigger(window.ECS.tms.data.evt);
    }
    fetch(`${process.env.GATSBY_API}/api/clickstream/uilog`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(window.ECS.tms.data)
    });
  }
}
export function postAdobeTracking(value: string) {
  if (
    typeof window !== 'undefined' &&
    typeof window.s_ecs !== 'undefined' &&
    typeof window.s_ecs.tl !== 'undefined'
  ) {
    window.s_ecs.tl(null, 'o', value);
  }
}
export class UiLog {
  uniqueOffersStored: string[] = [];

  getOffertraits() {
    return {
      booststatus: null,
      offerindicator: null,
      percentagematch: null,
      newoffer: 'N',
      offerType: 'public_generic'
    };
  }

  newUniqueShownOffers(offerIds: string[]) {
    const newOffers: string[] = [];
    offerIds.forEach((offer) => {
      if (!this.uniqueOffersStored.includes(offer)) {
        this.uniqueOffersStored.push(offer);
        newOffers.push(offer);
      }
    });
    return newOffers;
  }

  setECSFilter(filters: any): void {
    const filterObject = filters;
    if (typeof window !== 'undefined' && window.ECS && window.ECS.tms && window.ECS.tms.data) {
      if (!Object.prototype.hasOwnProperty.call(filterObject, 'trigger')) {
        filterObject.trigger = 'initial';
      }
      window.ECS.tms.data.filters = filterObject;
    }
  }

  returnOfferTraits(offerIds: string[]) {
    const traits: any = {};
    offerIds.forEach((id) => {
      traits[id] = this.getOffertraits();
    });
    return traits;
  }

  getRedirectLinkParams(params: ApplyLinkParams) {
    const fullParams: any = {
      previouspageid: getECSobjPropVal('previouspageid'),
      site: 'exp',
      sessionId: getECSobjPropVal('sessionid'),
      pageId: getECSobjPropVal('pageid'),
      ecsStaticId: getECSobjPropVal('ecsstaticid'),
      offerType: 'public_generic',
      customUrl: 'generic',
      placement: params.placement
    };
    if (params.filterFeatures) {
      fullParams.filterFeatures = params.filterFeatures;
    }
    return fullParams;
  }
}
